// Core imports
import { Fragment, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import { Typography } from 'antd';

// Misc imports
import { GraphContext } from './FlowGraph';

const PriorityTag = ({ nodeId, currentPriority }) => {
  const { elements = [] } = useContext(GraphContext);
  const incomingEdge = elements.filter((element) => element.data.nodeType === 'edge').find(edge => edge.target === nodeId);

  return (
    <Fragment>
      <Typography.Text
        className={classNames('order-input text-link fw-600', { 'd-none': !incomingEdge })}
      >
        {!currentPriority ? 1 : currentPriority}
      </Typography.Text>
    </Fragment>
  );
};

PriorityTag.propTypes = {
  nodeId: PropTypes.string,
  currentPriority: PropTypes.number
};

export default PriorityTag;
